export const INFINITY_ORB_GIFS = [
  {
    id: "ZmuShPwI5Z6ipoF7Bo",
    title: "Tuesday Tacos",
    tags: ["tuesday", "tacos", "infinity orb"],
  },
  {
    id: "MRMMqePWyxvvz1mGxO",
    title: "Good Night",
    tags: ["sleep", "good night", "sweet dreams"],
  },
  {
    id: "Pkr8CCtTPoKgLPWdog",
    title: "Sale Buy",
    tags: ["sale", "buy", "shopping"],
  },
  {
    id: "T48iIzYxd4zImeK15p",
    title: "Good Job",
    tags: ["nice", "great", "good job"],
  },
  {
    id: "l7ZzvDZHvvKIDjRFvL",
    title: "Blast Off",
    tags: ["buzz", "blast off", "infinity orb"],
  },
  {
    id: "k3mLsKaslSAr24Up4j",
    title: "Disappointed",
    tags: ["disappointed", "let down"],
  },
  {
    id: "9hh6ew6M9UqI9A0CmH",
    title: "Awesome",
    tags: ["cool", "nice", "awesome"],
  },
  {
    id: "8iOP5gcGafAlCbkp8r",
    title: "Winner",
    tags: ["celebrate", "winner", "winning", "jackpot"],
  },
  {
    id: "mWsWML97LjIiaGpFSx",
    title: "Popcorn",
    tags: ["movie", "popcorn", "watching", "spicy"],
  },
  {
    id: "flrTyQTDOIa4QX0BsU",
    title: "Knee Slapper",
    tags: ["funny", "haha", "hilarious"],
  },
  {
    id: "Lm5xutlxAJk7kAm0Tn",
    title: "Waiting",
    tags: ["waiting", "impatient", "patiently waiting"],
  },
  {
    id: "6sx8tfFCHmnwtilTK5",
    title: "Magic",
    tags: ["magic", "magician", "voila", "magic trick"],
  },
  {
    id: "hluQSBLxXJ3EjM4l45",
    title: "Happy New Year",
    tags: ["happy new year", "new year", "2026"],
  },
  {
    id: "ADkDFUnxRlnVrmTLhA",
    title: "Joke",
    tags: ["joke", "humor"],
  },
  {
    id: "3gtgdPPv2zINEH9sQ4",
    title: "No Good",
    tags: ["fail", "bad", "no good"],
  },
  {
    id: "2c7MsvlvTp26NYHY2p",
    title: "Cool Breeze",
    tags: ["winter", "door open", "cool breeze"],
  },
  {
    id: "rsUGFOOsRhHk1aubTg",
    title: "On The Road",
    tags: ["vacation", "driving", "traveling"],
  },
  {
    id: "V32YH3Xey9LtrQh1eu",
    title: "Forget About It",
    tags: ["no", "forget about it", "nope"],
  },
  {
    id: "a0w2ooPZSRZdtS5oNX",
    title: "Don't Care",
    tags: ["dont care", "whatever", "shrug"],
  },
  {
    id: "epMBDxO8E7ZDAgaRGk",
    title: "Good Morning",
    tags: ["good morning", "morning", "hello"],
  },
  {
    id: "sl2VHV3AaiTLIbqxKn",
    title: "Relax Reset",
    tags: ["relax", "reset", "chill"],
  },
  {
    id: "GTHJIMJs48oT5zE7bV",
    title: "Question What",
    tags: ["question", "what", "confused"],
  },
  {
    id: "h0SzqvD9dlHUlYUQ9I",
    title: "Ice Ice Baby",
    tags: ["ice", "freeze", "cold"],
  },
  {
    id: "uymnNvrI4MfRR6fpAa",
    title: "Get Lost",
    tags: ["get lost", "leave", "go away"],
  },
  {
    id: "SqMpJU4cmEECgS1nIx",
    title: "Awww",
    tags: ["valentines day", "awww", "love"],
  },
  {
    id: "tpsjCRvjkMID5TzZuk",
    title: "Run Race",
    tags: ["run", "race", "fast", "hurry"],
  },
  {
    id: "fZXFr2JJz0e8fOVyq8",
    title: "Locked In",
    tags: ["locked in", "focused", "working hard"],
  },
  {
    id: "njO1mslu9DIRpukZVL",
    title: "Too Fast",
    tags: ["weekend", "fast", "flash", "too fast"],
  },
  {
    id: "lAglN9F5SidCAt9VZs",
    title: "Ban Hammer",
    tags: ["hammer", "ban", "banned", "ban hammer"],
  },
  {
    id: "foaf6rF1AToX1XfT8O",
    title: "New Year Welcome",
    tags: ["happy new year", "welcome", "2026"],
  },
  {
    id: "kv0rRmL5soy2y3n9FT",
    title: "New Year New Me",
    tags: ["happy new year", "new me", "jan 1"],
  },
  {
    id: "iJZaa81BsjeaZlSnps",
    title: "Drool Love",
    tags: ["love", "cool", "drool"],
  },
  {
    id: "4KDKVDV0wzK0MR5TbV",
    title: "Yes",
    tags: ["yes", "agree", "correct"],
  },
  {
    id: "7imx9WrX4hrbnAflk7",
    title: "Awesome Spin",
    tags: ["awesome", "cool", "nice"],
  },
  {
    id: "Z06iXb6Gg67x6dA49l",
    title: "Disappointed",
    tags: ["disappointed", "sad", "let down"],
  },
  {
    id: "Mnwk8naJXjAVTjSIsa",
    title: "Ninja",
    tags: ["ninja", "sneaky", "stealth"],
  },
  {
    id: "cg4xtPaLQtcnpuVPFV",
    title: "Fight",
    tags: ["fight", "battle", "ready"],
  },
  {
    id: "37UjuCIdzkMEEP1ZBa",
    title: "Big Mad",
    tags: ["mad", "angry", "rage"],
  },
  {
    id: "JMIWcsT5TITahrYvnr",
    title: "Angry",
    tags: ["angry", "mad", "upset"],
  },
  {
    id: "9xtTKXAHT8qlk11sa4",
    title: "Pump It",
    tags: ["hype", "pump it", "excited"],
  },
  {
    id: "cXEj9klq0Ya5gsjy7C",
    title: "Hold My Beer",
    tags: ["watch this", "hold my beer", "challenge"],
  },
  {
    id: "pSPeeWKNQXsU0s7s6x",
    title: "Dog Puppy",
    tags: ["dog", "puppy", "cute"],
  },
  {
    id: "Z8ItqBMgcB3J6PxgbS",
    title: "Veterans Day",
    tags: ["veterans day", "usa", "salute"],
  },
  {
    id: "aQUAd6zeeHVVxYHnk1",
    title: "Infinity Spin",
    tags: ["spin", "infinity orb", "io"],
  },
  {
    id: "6EzmKL5DlWeIQYdHU0",
    title: "Playing Cards",
    tags: ["cards", "uno", "spades", "tonk"],
  },
  {
    id: "bFYZFhYXl8fZibEtSH",
    title: "Infinity",
    tags: ["infinity", "orb", "io"],
  },
  {
    id: "GqnpQ5wnjbAQskVIm1",
    title: "Beginning",
    tags: ["beginning", "start", "origin"],
  },
  {
    id: "H93Vi5d4dVUFB16Hwp",
    title: "Season 2",
    tags: ["season 2", "new", "infinity"],
  },
  {
    id: "sNB3Jt1yCw1k2vv4pi",
    title: "Sad",
    tags: ["sad", "left out", "stuck"],
  },
  {
    id: "JsiRTht0ChhhLnq6Sm",
    title: "Messed Up",
    tags: ["messed up", "oops", "mistake"],
  },
  {
    id: "ekle2LepJntAtfMfWH",
    title: "Yup Correct",
    tags: ["yup", "correct", "yes"],
  },
  {
    id: "zAF58IjQwaHlyH0eE1",
    title: "That Part",
    tags: ["that part", "yup", "agree"],
  },
].map((gif) => ({
  ...gif,
  gifUrl: `https://media.giphy.com/media/${gif.id}/giphy.gif`,
  previewUrl: `https://media.giphy.com/media/${gif.id}/200.gif`,
  sourceUrl: `https://giphy.com/gifs/CutiApp-${gif.id}`,
  source: "CutiApp",
}));

export const filterInfinityOrbGifs = (query = "", gifs = INFINITY_ORB_GIFS) => {
  const normalized = String(query || "").trim().toLowerCase();
  if (!normalized) return gifs;
  const tokens = normalized.split(/\s+/).filter(Boolean);

  return gifs.filter((gif) => {
    const haystack = [
      gif.title,
      gif.source,
      ...(Array.isArray(gif.tags) ? gif.tags : []),
    ]
      .join(" ")
      .toLowerCase();

    return tokens.every((token) => haystack.includes(token));
  });
};

export const MENTION_POPUP_MS = 4000;

export const normalizeMentionHandle = (value = "") =>
  String(value)
    .trim()
    .replace(/^@+/, "")
    .toLowerCase()
    .replace(/[^a-z0-9_.-]/g, "");

export const getDisplayName = (user = {}) =>
  user.name || user.username || user.senderName || user.sender || "Player";

export const getMentionHandle = (user = {}) =>
  normalizeMentionHandle(user.username || user.name || user.senderName || user.sender);

export const hasActiveSeasonPass = (user = {}) =>
  user?.seasonPass?.active === true ||
  user?.seasonPass === true ||
  user?.seasonPassActive === true;

export const truncateSnippet = (text = "", max = 96) => {
  const normalized = String(text || "").replace(/\s+/g, " ").trim();
  if (normalized.length <= max) return normalized;
  return `${normalized.slice(0, Math.max(0, max - 1)).trim()}...`;
};

export const getMessageSnippet = (message = {}, max = 96) => {
  if (message.type === "giphy" || message.gifUrl || message.giphy?.gifUrl) {
    return truncateSnippet(message.giphy?.title || message.gifTitle || "Infinity Orb GIF", max);
  }
  return truncateSnippet(message.text || "", max);
};

const dedupeCandidates = (candidates) => {
  const seen = new Set();
  return candidates
    .map((candidate) => {
      const id = candidate.id || candidate.uid || candidate.senderId || "";
      const name = getDisplayName(candidate);
      const handle = getMentionHandle(candidate);
      return {
        id,
        name,
        username: candidate.username || handle,
        avatar: candidate.avatar || candidate.imageUrl || "",
        handle,
      };
    })
    .filter((candidate) => {
      if (!candidate.id || !candidate.handle) return false;
      const key = `${candidate.id}:${candidate.handle}`;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
};

export const buildMentionCandidates = ({ userData, messages = [], extras = [] } = {}) => {
  const friendCandidates = Array.isArray(userData?.friends)
    ? userData.friends.map((friend) => ({
        id: friend.id || friend.uid,
        username: friend.username,
        name: friend.name || friend.username,
        avatar: friend.avatar || friend.imageUrl,
      }))
    : [];

  const messageCandidates = Array.isArray(messages)
    ? messages.map((message) => ({
        id: message.senderId,
        username: message.sender,
        name: message.senderName || message.sender,
        avatar: message.senderAvatar,
      }))
    : [];

  return dedupeCandidates([
    userData
      ? {
          id: userData.id,
          username: userData.username,
          name: userData.name || userData.username,
          avatar: userData.avatar || userData.imageUrl,
        }
      : null,
    ...friendCandidates,
    ...messageCandidates,
    ...extras,
  ].filter(Boolean));
};

export const getActiveMentionQuery = (text = "", caretIndex = text.length) => {
  const beforeCaret = String(text).slice(0, caretIndex);
  const match = beforeCaret.match(/(^|\s)@([a-zA-Z0-9_.-]{0,32})$/);
  if (!match) return null;
  return {
    query: normalizeMentionHandle(match[2] || ""),
    start: beforeCaret.length - (match[2] || "").length - 1,
    end: caretIndex,
  };
};

export const insertMentionToken = ({ text = "", caretIndex = text.length, candidate }) => {
  const active = getActiveMentionQuery(text, caretIndex);
  const token = `@${candidate.handle || getMentionHandle(candidate)} `;
  if (!active) {
    return {
      text: `${text.slice(0, caretIndex)}${token}${text.slice(caretIndex)}`,
      caretIndex: caretIndex + token.length,
    };
  }
  return {
    text: `${text.slice(0, active.start)}${token}${text.slice(active.end)}`,
    caretIndex: active.start + token.length,
  };
};

export const extractMentionTargets = (text = "", candidates = []) => {
  const byHandle = new Map();
  candidates.forEach((candidate) => {
    if (candidate.handle && candidate.id) byHandle.set(candidate.handle, candidate);
  });

  const found = new Map();
  const mentionRegex = /(^|\s)@([a-zA-Z0-9_.-]{2,32})\b/g;
  let match;
  while ((match = mentionRegex.exec(String(text)))) {
    const handle = normalizeMentionHandle(match[2]);
    const candidate = byHandle.get(handle);
    if (candidate?.id) found.set(candidate.id, candidate);
  }

  return Array.from(found.values()).map((candidate) => ({
    id: candidate.id,
    username: candidate.username || candidate.handle,
    name: candidate.name || candidate.username || candidate.handle,
  }));
};

export const buildReplyMetadata = (message) => {
  if (!message?.id) return {};
  return {
    replyToMessageId: message.id,
    replyToUserId: message.senderId || "",
    replyToUserName: message.senderName || message.sender || "Player",
    replyToSnippet: getMessageSnippet(message, 96),
  };
};

export const buildChatMessagePayload = ({
  text = "",
  mentionCandidates = [],
  replyTo = null,
  extra = {},
}) => {
  const cleanText = String(text || "").trim();
  const mentions = extractMentionTargets(cleanText, mentionCandidates);
  return {
    text: cleanText,
    mentionUserIds: mentions.map((mention) => mention.id),
    mentions,
    ...(replyTo ? buildReplyMetadata(replyTo) : {}),
    ...extra,
  };
};

export const buildGiphyMessagePayload = ({ gif, replyTo = null, extra = {} }) => {
  if (!gif?.id || !gif?.gifUrl) {
    throw new Error("Invalid GIF selection.");
  }
  return {
    type: "giphy",
    text: "",
    gifId: gif.id,
    gifUrl: gif.gifUrl,
    previewUrl: gif.previewUrl || gif.gifUrl,
    gifTitle: gif.title || "Infinity Orb GIF",
    giphy: {
      id: gif.id,
      gifUrl: gif.gifUrl,
      previewUrl: gif.previewUrl || gif.gifUrl,
      title: gif.title || "Infinity Orb GIF",
      source: gif.source || "CutiApp",
      sourceUrl: gif.sourceUrl || "",
    },
    mentionUserIds: [],
    mentions: [],
    ...(replyTo ? buildReplyMetadata(replyTo) : {}),
    ...extra,
  };
};

export const shouldShowMentionPreview = ({ message, selfId, chatOpen }) => {
  if (!message || !selfId || chatOpen) return false;
  if (message.senderId === selfId) return false;
  const ids = Array.isArray(message.mentionUserIds) ? message.mentionUserIds : [];
  return ids.includes(selfId);
};

export const renderTextWithMentionHighlights = (text = "") => {
  const parts = [];
  const mentionRegex = /(^|\s)(@[a-zA-Z0-9_.-]{2,32})\b/g;
  let lastIndex = 0;
  let match;

  while ((match = mentionRegex.exec(String(text)))) {
    const prefixStart = match.index;
    const mentionStart = prefixStart + match[1].length;
    if (mentionStart > lastIndex) {
      parts.push({ text: String(text).slice(lastIndex, mentionStart), mention: false });
    }
    parts.push({ text: match[2], mention: true });
    lastIndex = mentionStart + match[2].length;
  }

  if (lastIndex < String(text).length) {
    parts.push({ text: String(text).slice(lastIndex), mention: false });
  }

  return parts.length ? parts : [{ text: String(text), mention: false }];
};
